import { createAction } from 'redux-actions'

export const checkChangeAddressStart = createAction(
  'CHECK_CHANGE_ADDRESS_START'
)
export const checkChangeAddressSuccess = createAction(
  'CHECK_CHANGE_ADDRESS_SUCCESS'
)
export const checkChangeAddressFail = createAction('CHECK_CHANGE_ADDRESS_FAIL')
